import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type V2023_1KartePlannerCommentMonthlyAmountFragment = { __typename?: 'V2023_1KartePlannerCommentMonthlyAmount', usage: number, upperLimit?: number | null };

export const V2023_1KartePlannerCommentMonthlyAmountFragmentDoc = gql`
    fragment V2023_1KartePlannerCommentMonthlyAmount on V2023_1KartePlannerCommentMonthlyAmount {
  usage
  upperLimit
}
    `;